import useLeadListSources from "../../../datahooks/useLeadListSources";
import LeadListSourcesTag from "../../LeadListSourcesTag";

interface LeadListLeadSourcesProps {
  listId: string;
  isLoading: boolean;
  //the sources that contributed this lead, a subset of the list's own -
  //undefined while the row it belongs to is still loading
  sourceIds: string[] | undefined;
}

/** The sources one lead came from, narrowed down from the list's sources. */
export default function LeadListLeadSources({
  listId,
  sourceIds,
  isLoading,
}: LeadListLeadSourcesProps) {
  const { leadListSources, isLoadingLeadListSources } = useLeadListSources({
    listId,
  });

  //keeps the list's own order rather than the order of the lead's source ids
  const sources = sourceIds
    ? (leadListSources ?? []).filter(({ id }) => sourceIds.includes(id))
    : [];

  return (
    <LeadListSourcesTag
      sources={sources}
      //the row's own leads and the list's sources load separately
      isLoading={isLoading || isLoadingLeadListSources}
      isAlwaysCompact
    />
  );
}
